module.exports = __webpack_public_path__ + "img/icon_user_white.966d0128.svg";